import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Container, Row, Col, Button, Table, Label } from 'reactstrap';
import * as repairLogActions from '../../actions/repairLogActions';
import * as siteActions from '../../actions/siteActions';
import * as systemActions from '../../actions/systemActions';
import systemsToSelectOptions from '../../utils/systemSelectFormatter';
import sitesToSelectOptions from '../../utils/siteSelectFormatter';
import Select from 'react-select';
import RepairLog from './RepairLog';
import AddRepairLogModal from './AddRepairLogModal';
import { toast } from 'react-toastify';
import moment from 'moment/moment';
import { isEmpty } from '../../utils/objectChecker';

class RepairLogPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      systems: props.systems,
      sites: props.sites,
      selectedSystem: {},
      selectedSite: {},
      showModal: false,
      repairLogs: props.repairLogs.sort(function (a, b) {
        return new Date(b.logDate) - new Date(a.logDate);
      }),
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.repairLogs) {
      if (this.props.repairLogs !== nextProps.repairLogs) {
        this.setState({
          repairLogs: nextProps.repairLogs.sort(function (a, b) {
            return new Date(b.logDate) - new Date(a.logDate);
          }),
        });
      }
    }
  }

  componentWillMount() {
    const { systems } = this.props;
    if (systems.length > 0) return;
    this.props.actions.loadSystems();
    this.props.actions.loadSites();
  }

  handleSystemChange = (selectedOption) => {
    const sitesForSystem = this.props.sites.filter(
      (site) => site.systemId === selectedOption.value
    );
    const siteOptions = sitesToSelectOptions(sitesForSystem);
    this.setState({
      sites: siteOptions,
      selectedSystem: selectedOption,
      selectedSite: {},
    });
  };

  handleSiteChange = (selectedOption) => {
    this.setState({ selectedSite: selectedOption }, () => {
      this.loadRepairLogs(selectedOption.value);
    });
  };

  loadRepairLogs = () => {
    const { selectedSite } = this.state;
    if (selectedSite && selectedSite !== undefined)
      this.props.actions.loadLatestRepairLogs(selectedSite.value);
  };

  toggleModal = () => {
    this.setState({
      showModal: !this.state.showModal,
    });
  };

  createRepairLog = (date) => {
    const { repairLogs } = this.props;
    if (this.datesMatch(date, repairLogs)) {
      toast.error('Log for date already exists.');
      return;
    }
    const { selectedSite } = this.state;
    if (!selectedSite.value) {
      toast.error('Please select system and site');
      return;
    }

    this.props.actions
      .createRepairLog(date, selectedSite.value)
      .then(() => {
        toast.success('Repair log created.');
        this.props.history.push('/repair-logs');
      })
      .catch((error) => {
        toast.error(error.message);
      });
  };

  datesMatch = (date, logs) => {
    let match = false;
    logs.forEach(function (log) {
      const parsedDate = moment(log.logDate).format('YYYY-MM-DD');
      if (date === parsedDate) {
        match = true;
      }
    });
    return match;
  };

  render() {
    const { selectedSystem, selectedSite, repairLogs } = this.state;
    return (
      <div>
        <Container fluid={true}>
          <Row>
            <Col md={12}>
              <h1 className="text-center my-4">Repair Logs</h1>
            </Col>
          </Row>
          <Row className="mb-4">
            <Col md="6">
              <Label for="systemSelect" className="mr-2">
                System
              </Label>
              <Select
                name="systemSelect"
                value={selectedSystem}
                onChange={this.handleSystemChange}
                options={this.state.systems}
                className="mt-1"
              />
            </Col>
            <Col md={6}>
              <Label for="siteSelect" className="mr-2">
                Site
              </Label>
              <Select
                name="siteSelect"
                value={selectedSite}
                onChange={this.handleSiteChange}
                options={this.state.sites}
                className="mt-1"
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Button
                className="primary mb-2"
                disabled={isEmpty(selectedSite)}
                onClick={() => {
                  this.toggleModal();
                }}
              >
                Add
              </Button>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              {repairLogs.length > 0 ? (
                <Table>
                  <thead>
                    <tr>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {repairLogs.map((repairLog) => (
                      <RepairLog
                        key={repairLog.id}
                        repairLog={{ ...repairLog }}
                      />
                    ))}
                  </tbody>
                </Table>
              ) : (
                <h4 className="my-4">No logs found</h4>
              )}
            </Col>
          </Row>
          <AddRepairLogModal
            show={this.state.showModal}
            createRepairLog={this.createRepairLog}
            toggle={this.toggleModal}
          />
        </Container>
      </div>
    );
  }
}

RepairLogPage.propTypes = {
  repairLogs: PropTypes.array,
  actions: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  const filtered = state.systems.filter((s) => s.isActive);
  const systems = systemsToSelectOptions(filtered);
  return {
    systems: systems,
    sites: state.sites,
    repairLogs: state.repairLogs,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...siteActions, ...systemActions, ...repairLogActions },
      dispatch
    ),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(RepairLogPage)
);



// WEBPACK FOOTER //
// ./src/components/repair-log/RepairLogPage.js